import types from '../types';

const cashback = (
  state = { loading: true, cashbacks: null, userCashbacks: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_CASHBACKS_START:
    case types.GET_USERS_CASHBACKS_START:
      return { ...state, loading: true };

    case types.GET_CASHBACKS_FAILURE:
    case types.GET_USERS_CASHBACKS_FAILURE:
      return { ...state, loading: false };

    case types.GET_CASHBACKS_SUCCESS:
      return { ...state, cashbacks: payload, loading: false };
    case types.GET_USERS_CASHBACKS_SUCCESS:
      return { ...state, userCashbacks: payload, loading: false };

    case types.DELETE_CASHBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        cashbacks: state.cashbacks.filter(cash => cash.id !== +payload),
      };

    default:
      return state;
  }
};

export default cashback;
